module.exports = __webpack_public_path__ + "img/ring_y_skip_null_0@2x.d2e61347.png";